module.exports = __webpack_public_path__ + "media/images/bank_images/banco_fiat-6bdf3232e2834888a41a2da05ccd64c7.png";